import { Button } from "@mui/material";
import { HandleUpdateItem } from "../../utils/basicCrud/HandleUpdateItem";
import Modal from "../ui/Modal"
import NoDataScreen from "../ui/temp-screens/NoDataScreen";
import { FaLink, FaTrash } from "react-icons/fa";
import AddIcon from "@mui/icons-material/Add";
import { useState } from "react";

export const LinkProyectoGrabacion = ({s}) => {

  const [activeModal, setActiveModal] = useState(false)

  const [linksProyectoBorrador, setLinksProyectoBorrador] = useState(s.grabacionProyectoBorrador ? s.grabacionProyectoBorrador : [])
  
  const addLink = (stateSetter) => {
    stateSetter((prev) => [...prev, { link: "" }]);
  };
  
  const updateLink = (stateSetter, index, newValue) => {
    stateSetter((prev) =>
      prev.map((l, i) => (i === index ? { ...l, link: newValue } : l))
    );
  };
  
  const deleteLink = (stateSetter, index) => {
    stateSetter((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <>
      <Modal
        activeModal={activeModal}
        onClose={() => setActiveModal(false)}
        centered
        title="Links de las grabaciones del proyecto (borrador) por el especialista"
      >
        <div className="max-h-[75vh] overflow-y-auto">
          {linksProyectoBorrador.length === 0 ? (
            <div className="h-[150px]">
              <NoDataScreen border/>
            </div>
          ) : (
            linksProyectoBorrador.map((l, i) => (
              <div className="mb-4 mt-4" key={i}>
                <label className="text-xs block text-gray-700 mb-2">
                  Link {i + 1}
                </label>
                <div className="flex">
                  <span className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-e-0 border-gray-300 border-e-0 rounded-s-md">
                    <FaLink />
                  </span>
                  <input
                    type="text"
                    placeholder="Introduce un link"
                    value={l.link}
                    onChange={(e) => updateLink(setLinksProyectoBorrador, i, e.target.value)}
                    className="text-xs bg-gray-50 border text-gray-900 focus:ring-blue-500 focus:border-blue-500 block flex-1 min-w-0 w-full text-sm border-gray-300 p-2.5"
                  />
                  <button 
                    className="text-xs inline-flex items-center px-3 text-sm text-gray-900 bg-gray-200 border rounded-s-0 border-gray-300 border-s-0 rounded-e-md"
                    onClick={() => deleteLink(setLinksProyectoBorrador, i)}
                  >
                    <FaTrash />
                  </button>
                </div>
              </div>
            ))
          )}
        </div>

        <Button
          variant="contained"
          endIcon={<AddIcon />}
          sx={{
            fontWeight: "bold",
            fontFamily: "poppins",
            paddingBlock: "4px",
            backgroundColor: "#a5cef5",
            marginTop: "20px",
            textTransform: "none",
            borderRadius: "8px",
            width: "100%",
            "&:hover": { backgroundColor: "#1d80e0" },
          }}
          onClick={() => addLink(setLinksProyectoBorrador)}
        >
          Nuevo Link
        </Button>

        <Button
          variant="contained"
          sx={{
            fontWeight: "bold",
            fontFamily: "poppins",
            paddingBlock: "4px",
            backgroundColor: "#ff6400",
            marginTop: "20px",
            textTransform: "none",
            borderRadius: "8px",
            width: "100%",
            "&:hover": { backgroundColor: "#bb4a03" },
          }}
          onClick={() => {HandleUpdateItem({
            route: "serviciosCotizaciones",
            id: s.id,
            field: "grabacionProyectoBorrador",
            value: linksProyectoBorrador
          })
          setActiveModal(false)
        }}
        >
          Guardar
        </Button>
      </Modal>

      <div className="flex flex-col gap-1 items-center justify-center w-full">    
        <span className="text-xs font-bold bg-gray-50 w-full px-2 py-1 rounded">
          Links proyecto grabación
        </span>
        <button 
          type="text"
          className="text-xs w-full text-gray-700 bg-white font-semibold hover:bg-gray-50 transition-all duration-100 border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
          onClick={() => setActiveModal(true)}
        >
          Ver links 
        </button>
      </div>
    </>
  )
}